import React, { useState } from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';
export function QuoteForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    make: '',
    model: '',
    year: '',
    service: 'Full Detail',
    notes: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thanks! We will contact you shortly with your quote.');
  };
  return <section id="quote" className="py-20 md:py-32 bg-[#111111] relative" data-id="element-146">
      {/* Decorative accent lines */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#111111] via-[#7FD4D4] to-[#111111] opacity-30" data-id="element-147"></div>

      <div className="container mx-auto px-4 md:px-6" data-id="element-148">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-149">
          {/* Form Side */}
          <div className="w-full lg:w-2/3" data-id="element-150">
            <div className="mb-10" data-id="element-151">
              <h2 className="text-3xl md:text-5xl font-black text-white uppercase mb-4" data-id="element-152">
                Ready for a Showroom Shine?
              </h2>
              <p className="text-xl text-white/70" data-id="element-153">
                Get your instant quote in 30 seconds.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-154">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-155">
                <div className="space-y-2" data-id="element-156">
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-157">
                    Name
                  </label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="John Doe" required data-id="element-158" />
                </div>
                <div className="space-y-2" data-id="element-159">
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-160">
                    Email
                  </label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="john@example.com" required data-id="element-161" />
                </div>
                <div className="space-y-2" data-id="element-162">
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-163">
                    Phone
                  </label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="(602) 555-0123" required data-id="element-164" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-165">
                <div className="space-y-2" data-id="element-166">
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-167">
                    Make
                  </label>
                  <input type="text" name="make" value={formData.make} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="Tesla" data-id="element-168" />
                </div>
                <div className="space-y-2" data-id="element-169">
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-170">
                    Model
                  </label>
                  <input type="text" name="model" value={formData.model} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="Model S" data-id="element-171" />
                </div>
                <div className="space-y-2" data-id="element-172">
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-173">
                    Year
                  </label>
                  <input type="text" name="year" value={formData.year} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="2024" data-id="element-174" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-175">
                <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-176">
                  Service Interested In
                </label>
                <select name="service" value={formData.service} onChange={handleChange} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors appearance-none" data-id="element-177">
                  <option data-id="element-178">Interior Only</option>
                  <option data-id="element-179">Exterior Only</option>
                  <option data-id="element-180">Full Detail (Gold Package)</option>
                  <option data-id="element-181">Platinum Package (Ceramic)</option>
                  <option data-id="element-182">RV Detailing</option>
                  <option data-id="element-183">Boat Detailing</option>
                  <option data-id="element-184">Fleet Services</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-185">
                <label className="text-xs font-bold text-white/60 uppercase tracking-wider" data-id="element-186">
                  Any Special Requests?
                </label>
                <textarea name="notes" value={formData.notes} onChange={handleChange} rows={4} className="w-full bg-[#1A1A1A] border border-white/10 text-white px-4 py-3 rounded-sm focus:outline-none focus:border-[#7FD4D4] transition-colors" placeholder="Tell us about any specific stains, scratches, or concerns..." data-id="element-187"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#7FD4D4] text-black font-black uppercase tracking-widest text-lg py-4 rounded-sm hover:bg-[#6BC4C4] transition-colors shadow-lg shadow-[#7FD4D4]/10" data-id="element-188">
                Get A Quote
              </button>
            </form>
          </div>

          {/* Contact Info Side */}
          <div className="w-full lg:w-1/3 space-y-6" data-id="element-189">
            <div className="bg-[#1A1A1A] border border-white/10 p-8 rounded-sm" data-id="element-190">
              <h3 className="text-xl font-bold text-white uppercase mb-6" data-id="element-191">
                Contact Info
              </h3>

              <div className="space-y-6" data-id="element-192">
                <div className="flex items-start" data-id="element-193">
                  <div className="bg-[#111] p-3 rounded-full mr-4 text-[#7FD4D4]" data-id="element-194">
                    <Phone size={20} data-id="element-195" />
                  </div>
                  <div data-id="element-196">
                    <p className="text-xs text-white/50 uppercase font-bold mb-1" data-id="element-197">
                      Phone
                    </p>
                    <a href="tel:602-641-5089" className="text-white font-bold text-lg hover:text-[#7FD4D4] transition-colors" data-id="element-198">
                      602-641-5089
                    </a>
                    <p className="text-white/40 text-sm mt-1" data-id="element-199">Call or Text</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-200">
                  <div className="bg-[#111] p-3 rounded-full mr-4 text-[#7FD4D4]" data-id="element-201">
                    <Clock size={20} data-id="element-202" />
                  </div>
                  <div data-id="element-203">
                    <p className="text-xs text-white/50 uppercase font-bold mb-1" data-id="element-204">
                      Hours
                    </p>
                    <p className="text-white font-medium" data-id="element-205">
                      Mon - Sat: 8am – 6pm
                    </p>
                    <p className="text-white/40 text-sm" data-id="element-206">Sunday: Closed</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-207">
                  <div className="bg-[#111] p-3 rounded-full mr-4 text-[#7FD4D4]" data-id="element-208">
                    <MapPin size={20} data-id="element-209" />
                  </div>
                  <div data-id="element-210">
                    <p className="text-xs text-white/50 uppercase font-bold mb-1" data-id="element-211">
                      Location
                    </p>
                    <p className="text-white font-medium" data-id="element-212">
                      Phoenix, AZ & Metro Area
                    </p>
                    <p className="text-white/40 text-sm" data-id="element-213">We come to you!</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-white/10" data-id="element-214">
                <a href="#booking" className="block w-full text-center border border-white/20 text-white font-bold uppercase tracking-wide py-3 rounded-sm hover:bg-white hover:text-black transition-colors" data-id="element-215">
                  Book Online Instead
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}